import type { AudienceStatus } from '../types';

/** Why a definition in a given status cannot take new destinations. */
export const DELIVERY_BLOCKED_REASONS = {
  paused: 'Resume the audience to deliver it',
  deleted: "Deleted audiences can't be delivered"
} as const satisfies Partial<Record<AudienceStatus, string>>;

/** The reason a definition cannot take new destinations, or null when it can. */
export const deliveryBlockedReason = (status: AudienceStatus): string | null =>
  status === 'paused' || status === 'deleted' ? DELIVERY_BLOCKED_REASONS[status] : null;
